import React, { useState, useContext, useEffect } from 'react'
import '../App.css'
import axios from 'axios';
// import { DropdownContext, DropdownProvider } from '../contexts/DropdownContext.js';
import DragAndDropUpload from './Upload/DragAndDropUpload.js';
import TitleInput from './Upload/TitleInput.js';
import DescriptionInput from './Upload/DescriptionInput.js';
import KeywordsInput from './Upload/KeywordsInput.js';
import { useUploadContext } from '../contexts/UploadContext.js';
import useFetchDropdownOptions from "../hooks/UseFetchDropdownOptions.js";

import DataSearch from '../pages/DataSearchWrapper.js';
import Dropdown from './Dropdown.js';
import { api, API_ORIGIN } from "../apiClient.js";

function UploadWrapper() {
  const {
    uploadData,
    updateUploadData,
    uploadStatus,
    setUploadStatus,
  } = useUploadContext();
  // const [uploadedFiles, setUploadedFiles] = useState([]);

  const [uploadedFiles, setUploadedFiles] = useState({ files: [], fileNames: [] });

  const handleFilesUploaded = (data) => {
    setUploadedFiles(data); // 接收子組件回傳的檔案和名稱
  };

  const [fileUrls, setFileUrls] = useState([]);

  // const { selectedOption } = useContext(DropdownContext);

  // const [file, setFile] = useState(null);
  // const [formData, setFormData] = useState({ title: "", description: "", keywords: "" });
  // const [uploadStatus, setUploadStatus] = useState("");

  // // 處理文件選擇
  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };

  // // 處理表單數據改變
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };


  const [caseNoOptions, setCaseNoOptions] = useState([]);
  const [selectedCaseNo, setSelectedCaseNo] = useState('');

  // useEffect(() => {
  //   // 從後端 API 獲取 case_no 資料
  //   const fetchCaseNo = async () => {
  //     try {
  //       const response = await fetch('http://localhost:5000/get-case-no');
  //       const data = await response.json();
  //       if (data.case_no) {
  //         // 將 case_no 轉換為帶 value 和 label 的結構
  //         const options = data.case_no.map((caseNo) => ({
  //           value: caseNo,
  //           label: caseNo,
  //         }));
  //         setCaseNoOptions(options);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching case_no:', error);
  //     }
  //   };

  //   fetchCaseNo();
  // }, []);

  const handleCaseNoChange = (value) => {
    setSelectedCaseNo(value);
  };



  const {
    CaseNameOptions, // 動態生成的 options 狀態
    setCaseNameOptions, // 動態生成的狀態 setter
    SelectedCaseName, // 動態生成的選中值狀態
    setSelectedCaseName, // 動態生成的選中值 setter
    handleOptionChange, // 動態生成的 change 處理函式
  } = useFetchDropdownOptions({
    // apiUrl: 'http://localhost:5000/get_case_name', // API 路徑
    apiUrl: `${API_ORIGIN}/options/case_name`,
    // apiUrl: 'http://localhost:5000/options/case_name', // API 路徑
    optionKey: 'value',      // 下拉選單選項的值名稱
    labelKey: 'label',       // 下拉選單顯示文字的名稱
    // dataKey: 'case_name',    // API 回應中數據的鍵名稱
    dataKey: null,    // API 回應中數據的鍵名稱
    defaultOptionsName: 'CaseNameOptions', // 自定義 options 名稱
    defaultSelectedName: 'SelectedCaseName', // 自定義選中值名稱,
    transformItem: (item) => ({
      value: item.value,
      label: item.label,
    }),
  });

  // 上傳文件與數據
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 從 uploadData.files 中獲取檔案名稱
    // const title = uploadData.files?.[0] || ""; // 獲取第一個檔案名稱，預設為空字串
    // // 收集所有表單數據
    // const fileData = {
    //   // title: uploadData.fileName[0], // 使用同步的檔案名稱
    //   access: selectedAccess,
    //   client: selectedClient,
    //   project: selectedProject,
    //   fileName: uploadData.fileName,
    //   file: uploadData.file,
    // };
    // console.log(fileData);
    // updateUploadData(fileData);

    // console.log("File Data to Update:", fileData); // 確認即將更新的資料

    console.log("uploadData:", uploadData); // 確認即將更新的資料

    const payload = new FormData();
    // 遍歷 uploadData 陣列，將每個檔案和元數據附加到 FormData
    uploadData.forEach((data, index) => {
      // 將元數據轉為 JSON 字串
      payload.append(`metadata_${index}`, JSON.stringify({
        access: data.access,
        client: data.client,
        case_no: "case_no",
        case_name: data.case_name,
        type: data.type,
        file_name: data.fileName,
        relative_path: data.file?.relativePath || data.fileName  // ✅ 新增這行
      }));
      // 附加檔案
      payload.append(`file_${index}`, data.file); // 檔案物件
    });
    // for (let pair of payload.entries()) {
    //   console.log(pair[0], pair[1]); // 驗證 payload
    // }

    try {
      setUploadStatus("上傳中...");
      // const response = await axios.post("http://127.0.0.1:5000/data-upload", payload, {
      const response = await api.post("/data-upload", payload, {
        headers: {
          // Authorization: `Bearer ${loginResponse.accessToken}`,
          "Content-Type": "multipart/form-data",
          // timeout: 300000  // 5 分鐘
        },
      });
      console.log(response);
      setUploadStatus("上傳完成！");
      // 更新 fileUrls 狀態
      setFileUrls(response.data); // response.data 是一個包含字典的數組

    } catch (error) {
      console.error("上傳失敗:", error);
      setUploadStatus("上傳失敗！");
    }


    // if (!file || !formData.title || !formData.description || !formData.keywords) {
    //   setUploadStatus("請填寫所有欄位並選擇文件！");
    //   return;
    // }

    // const payload = new FormData();
    // payload.append("file", file);
    // payload.append("title", formData.title);
    // payload.append("description", formData.description);
    // payload.append("keywords", formData.keywords);

    // try {
    //   setUploadStatus("上傳中...");
    //   const response = await axios.post("http://127.0.0.1:5000/upload", payload, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
    //   setUploadStatus(`上傳成功！文件 URL: ${response.data.url}`);
    // } catch (error) {
    //   console.error("上傳失敗:", error);
    //   setUploadStatus("上傳失敗！");
    // }
  };


  // 選單選項
  const [accessOptions, setAccessOptions] = useState([
    { value: "勞動部", label: "勞動部" },
    { value: "文化部", label: "文化部" },
  ]);
  const [clientOptions, setClientOptions] = useState([
    { value: "一一", label: "一一" },
    { value: "十十", label: "十十" },
  ]);
  const [projectOptions, setProjectOptions] = useState([
    { value: "保誠", label: "保誠" },
    { value: "屏東縣王船博物館", label: "屏東縣王船博物館" },
  ]);
  const [typeOptions, setTypeOptions] = useState([
    { value: "Material", label: "Material" },
    { value: "Script", label: "Script" },
    { value: "A copy", label: "A copy" },
    { value: "B copy", label: "B copy" },
    { value: "C copy", label: "C copy" },
  ]);

  const [selectedAccess, setSelectedAccess] = useState(accessOptions[0].value);
  const [selectedClient, setSelectedClient] = useState(clientOptions[0].value);
  const [selectedProject, setSelectedProject] = useState(projectOptions[0].value);
  const [selectedType, setSelectedType] = useState(typeOptions[0].value);
  const [formData, setFormData] = useState({
    access: selectedAccess, // 例：從輸入框或下拉選單中獲取
    client: selectedClient,
    case_name: selectedProject,
    type: selectedType,
  });


  useEffect(() => {
    setSelectedProject(SelectedCaseName); // 同步 case name 的值給 selectedProject
  }, [SelectedCaseName]);


  // 當 selectedAccess、selectedClient 或 selectedProject 改變時，自動更新 formData
  useEffect(() => {
    setFormData({
      access: selectedAccess,
      client: selectedClient,
      case_name: selectedProject,
      type: selectedType,
    });

    // 更新每個檔案的 access, client, project 屬性
    const updatedData = uploadData.map((data) => ({
      ...data,
      access: selectedAccess,
      client: selectedClient,
      case_name: selectedProject,
      type: selectedType,
      file: data.file,  // ✅ 保留原始 file 包含 relativePath
    }));

    // 更新 Context 或 state 中的 uploadData
    updateUploadData(updatedData);

    console.log(uploadData);
  }, [selectedAccess, selectedClient, selectedProject, selectedType]);

  const handleAccessChange = (value) => {
    setSelectedAccess(value);
  };
  const handleClientChange = (value) => {
    setSelectedClient(value);
  };
  const handleProjectChange = (value) => {
    setSelectedProject(value);
  };
  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  return (
    <>
      <div className='sidebar-header'>— Database —</div>
      {/* <div className='wrapper'> */}
      <form onSubmit={handleSubmit} className='sidebar-form'>
        <div className='sidebar-block'>
          <div className="blue-block">
            <img src='./doc.png' style={{ width: "7%" }}></img>
            Database Upload
          </div>
          <div
            className='block-row'
          >
            <label>Access:</label>
            <Dropdown
              label="Access: "
              name="access"
              options={accessOptions}
              value={selectedAccess}
              onChange={handleAccessChange}
              setOptions={setAccessOptions}
              block="database-doropdown"
            />
          </div>
          <div
            className='block-row'
          >
            <label>Client:</label>
            <Dropdown
              label="Client: "
              name="client"
              options={clientOptions}
              value={selectedClient}
              onChange={handleClientChange}
              setOptions={setClientOptions}
              block="database-doropdown"
            />
          </div>

          <div
            className='block-row'
          >
            <label>Case Name:</label>
            <Dropdown
              label="Case Name: "
              name="case_name"
              options={CaseNameOptions}
              value={SelectedCaseName}
              onChange={handleOptionChange}
              setOptions={setCaseNameOptions}
              disableAutoFetch={true} // ✅ 不要自動 fetch
              block="database-doropdown"
            />
          </div>
          <div
            className='block-row'
          >
            <label>Type:</label>
            <Dropdown
              label="Type: "
              name="type"
              options={typeOptions}
              value={selectedType}
              onChange={handleTypeChange}
              setOptions={setTypeOptions}
              block="database-doropdown"
            /></div>
          <DragAndDropUpload commonData={formData} />
        </div>
        <div className='database-selected'>
          {[
            { label: "Access", value: selectedAccess },
            { label: "Client", value: selectedClient },
            { label: "Project", value: selectedProject },
            { label: "Type", value: selectedType },
            // { label: "File", value: uploadData },
          ].map((item, idx) => (
            <div key={idx}>
              {item.value && (
                <img src='./complete.png' alt="done" style={{ width: "8%" }} />
              )}
              {item.label} selected: {item.value}
            </div>
          ))}
          {/* <div>Access selected: {selectedAccess}</div>
          <div>Client selected: {selectedClient}</div>
          <div>Project selected: {selectedProject}</div>
          <div>Type selected: {selectedType}</div> */}

          <div>
            {uploadData.length > 0 && (
              <img src='./complete.png' alt="done" style={{ width: "8%" }} />
            )}File selected:</div>
          <ul>
            {uploadData.map((entry, index) => (
              <li key={index}>{entry.fileName}</li>
            ))}
          </ul>
        </div>
        <button className='orange-button' type="submit">
          <img src='./arrow03.png' style={{ width: "30%" }}></img>
          Upload</button>
        <br />
        {/* <div>
            <label>標題：</label>
            <input type="text" name="title" value={formData.title} onChange={handleInputChange} />
          </div>
          <div>
            <label>描述：</label>
            <textarea name="description" value={formData.description} onChange={handleInputChange}></textarea>
          </div>
          <div>
            <label>關鍵字（用逗號分隔）：</label>
            <input type="text" name="keywords" value={formData.keywords} onChange={handleInputChange} />
          </div>
          <div>
            <label>上傳文件：</label>
            <input type="file" name="file" onChange={handleFileChange} />
          </div> */}
      </form>
      <p>{uploadStatus}</p>
      {uploadStatus === "上傳完成！" &&
        fileUrls
          .slice() // 建議先複製，避免改動原本的 state
          .sort((a, b) => {
            if (a.status === "failed" && b.status !== "failed") return -1;
            if (a.status !== "failed" && b.status === "failed") return 1;
            return 0;
          })
          .map((file, index) => (
            <div style={{ display: 'grid', gap: '8px', marginBottom: '1rem' }}>
              <div><strong>檔名：</strong>{file.file_name}</div>
              <div><strong>狀態：</strong>{file.status}</div>
              {file.reason && <div style={{ color: 'red' }}><strong>錯誤原因：</strong>{file.reason}</div>}
              {file.view_url && (
                <a href={file.view_url} target="_blank" rel="noopener noreferrer">檔案檢視連結</a>
              )}
              {file.download_url && (
                <a href={file.download_url} target="_blank" rel="noopener noreferrer">檔案下載連結（有效期1小時）</a>
              )}
            </div>
          ))}


      {/* {uploadStatus === "上傳完成！" &&
        fileUrls.map((file, index) => (
          <div key={index}>
            <p>檔名：{file.fileName}</p>
            <p>狀態：{file.status}</p>
            <ul>
              <li>檔名：{file.fileName}</li>
              <a href={file.view_url} target="_blank" rel="noopener noreferrer">檔案檢視連結</a>
              <br />
              <a href={file.download_url} target="_blank" rel="noopener noreferrer">檔案下載連結(有效期1小時)</a>
            </ul>
          </div>
        ))
      } */}
      {/* <DataSearch /> */}
      {/* </div> */}
    </>
  );
}

export default UploadWrapper;
